var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14q-.825 0-1.413-.588Q10 12.825 10 12V6q0-.825.587-1.412Q11.175 4 12 4t1.413.588Q14 5.175 14 6v6q0 .825-.587 1.412Q12.825 14 12 14Zm-1 7v-3.1q-2.475-.35-4.237-2.15Q5 13.95 5 11.5h2q0 1.875 1.313 3.188Q9.625 16 11.5 16t3.188-1.312Q16 13.375 16 11.5h2q0 2.45-1.763 4.25-1.762 1.8-4.237 2.15V21Zm1-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.b7ca7bf49da643ebc6abc51acdafce7d.svg";
export { ForwardRef as ReactComponent };